import Vue from "vue";
import Vuex from "vuex";
const IdentityKey = "app.state.id";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false,
        authed: false,
        inited: false,
        menu: false,
        id: {},
        modal: {
            active: false,
            text: null
        },
        toast: {
            active: false,
            text: null,
            color: null
        },
        products: [],
        timers: {}
    },
    mutations: {
        init (state) {
            let id = localStorage.getItem(IdentityKey);

            if (id)
                Object.assign(state.id, JSON.parse(id));
        },
        auth (state, data) {
            state.id = {
                token: data.token,
                email: data.email,
                displayName: data.displayName,
                customer: data.customer,
                apiKey: data.apiKey,
                admin: data.permissions.includes("admin")
            };
            state.authed = true;

            localStorage.setItem(IdentityKey, JSON.stringify(state.id));
        },
        reauth (state, token) {
            state.id.token = token;
        },
        update (state, data) {
            state.id.email = data.email;
            state.id.displayName = data.displayName;
        },
        deauth (state) {
            state.authed = false;
            state.id = null;
            state.products = [];
            localStorage.removeItem(IdentityKey);
        },
        mutate (state, newState) {
            Object.assign(state, newState);
        },
        async load (state, promise) {
            try {
                state.loading = true;

                return await promise(state);
            } finally {
                state.loading = false;
            }
        }
    }
});